import React from "react";
import { Link } from "gatsby";
import { menuLinks } from "../common/utils/page_url_utils";

const CTALink_Module = (props) => {

    var menu_link = props?.item?.menu_item || props?.item?.menu
    var page_url = props?.item?.custom_link ? props?.item?.custom_link : menu_link ? menuLinks(menu_link) : "";
    
    const scrollTop = () => {
        window.scrollTo(0,0)
    }

    return(
        <>
        {page_url ?
            <Link to={page_url} 
            // title="Bulk Enquiry"
              target={props?.item?.target === "new_window" ? "_blank" : "_self"} {...props}>
                {props?.item.label === "Wishlist" ? <i className="icon-hearteen"></i> : props?.item.label} 
                {props.children}
            </Link>
            :
            <a href="javascript:;" {...props}>  
                {props?.item.label}
                {props.children}
            </a>
        }
        </>
    )
}
export default CTALink_Module;